import React, { useState } from 'react';

const Index = ({ name, value, labeling, checked, isAlt, handleChange, ...props }) => {
    const [check, setCheck] = useState(checked || false);
    const onChangehandler = () => {
        handleChange(value, check);
        setCheck((prev) => !prev);
    };
    return (
        <div {...props} className="select_box_comp_comp">
            <input
                id={name}
                type="checkbox"
                className="styled-checkbox"
                name={name}
                onChange={onChangehandler}
                checked={isAlt ? checked : check}
                value={labeling.toLocaleLowerCase()}
            />
            <label htmlFor={name} className="select_box_comp_comp_input">
                {labeling}
            </label>
        </div>
    );
};

export default Index;
